import { render, staticRenderFns } from "./choosetagdialog.vue?vue&type=template&id=5fabd27c&scoped=true"
import script from "./choosetagdialog.vue?vue&type=script&lang=js"
export * from "./choosetagdialog.vue?vue&type=script&lang=js"
import style0 from "./choosetagdialog.vue?vue&type=style&index=0&id=5fabd27c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fabd27c",
  null
  
)

export default component.exports